// // MODIFIED DutyList with role-based checkboxes for export only
// import React, { useEffect, useState, useRef } from "react";
// import axios from "axios";
// import jsPDF from "jspdf";
// import autoTable from "jspdf-autotable";
// import html2canvas from "html2canvas";
// import * as XLSX from "xlsx";
// import { saveAs } from "file-saver";

// import logoLeft from "../../assets/img/logo/new-logo.png";
// import logoRight from "../../assets/img/logo/punjab-logo.png";

// const DutyList = () => {
//   const [duties, setDuties] = useState([]);
//   const [filter, setFilter] = useState({ date: "", section: "", name: "" });
//   const [doctorList, setDoctorList] = useState([]);
//   const [editingIndex, setEditingIndex] = useState(null);
//   const [editData, setEditData] = useState({});
//   const [currentPage, setCurrentPage] = useState(1);
//   const [selectedRoles, setSelectedRoles] = useState({
//     Doctor: true,
//     Nurse: false,
//     FireFighting: false,
//     RapidResponseGround: false,
//     RapidResponseFirst: false, // ✅ NEW ROLE
//   });
//   const [fireTeam, setFireTeam] = useState([]);

//   const itemsPerPage = 8;
//   const tableRef = useRef();
//   const fileDate = filter.date || new Date().toISOString().split("T")[0];
//   const readableDate = filter.date
//     ? new Date(filter.date).toLocaleDateString("en-GB")
//     : new Date().toLocaleDateString("en-GB");

//   useEffect(() => {
//     axios.get("https://ricgop.online/backend/getDuties.php").then((res) => {
//       const cleaned = res.data.map((d) => ({
//         ...d,
//         name: d.name.trim(),
//         contact: d.contact.trim(),
//         role: d.role.trim(),
//         section: d.section.trim(),
//         on_call: d.on_call.trim(),
//         duty_date: d.duty_date.trim(),
//       }));
//       setDuties(cleaned);
//       const names = [...new Set(cleaned.map((d) => d.name))];
//       setDoctorList(names);
//     });

    

//     axios.get("https://ricgop.online/backend/getFireTeam.php").then((res) => {
//       const fireCleaned = res.data.map((f) => ({
//         delegation: (f.delegation_field || "").trim(),
//         responsible: (f.responsible_person || "").trim(),
//         created_at: (f.created_at || "").trim(),
//       }));
//       setFireTeam(fireCleaned);
//     });
//   }, []);

//   const filtered = duties.filter(
//     (d) =>
//       (!filter.date || d.duty_date === filter.date) &&
//       (!filter.section ||
//         d.section.toLowerCase().includes(filter.section.toLowerCase())) &&
//       (!filter.name || d.name === filter.name)
//   );

//   const indexOfLastItem = currentPage * itemsPerPage;
//   const indexOfFirstItem = indexOfLastItem - itemsPerPage;
//   const currentItems = filtered.slice(indexOfFirstItem, indexOfLastItem);
//   const totalPages = Math.ceil(filtered.length / itemsPerPage);

//   const handleEdit = (id) => {
//     const duty = duties.find((d) => d.id === id);
//     if (duty) {
//       setEditingIndex(id);
//       setEditData({ ...duty });
//     }
//   };

//   const handleEditChange = (field, value) => {
//     setEditData((prev) => ({ ...prev, [field]: value }));
//   };

//   const handleCancelEdit = () => {
//     setEditingIndex(null);
//     setEditData({});
//   };

//   const handleSaveEdit = () => {
//     const updated = duties.map((d) =>
//       d.id === editingIndex ? { ...d, ...editData } : d
//     );
//     setDuties(updated);
//     setEditingIndex(null);
//     setEditData({});
//   };




// const exportToUrduPDF = async () => {
//   const doc = new jsPDF({ orientation: "landscape" });
//   const pageWidth = doc.internal.pageSize.getWidth();

//   doc.setFont("Jameel");
//   doc.setFontSize(16);

//   // Urdu Header
//   doc.text("راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی", pageWidth / 2, 25, { align: "center" });
//   doc.setFontSize(12);
//   doc.text("پارٹ ۱ (ایوننگ / نائٹ ڈیوٹی روسٹر)", pageWidth / 2, 35, { align: "center" });

//   // Urdu Table Data
//   const urduData = filtered.map((d, i) => [
//     `${i + 1}`,
//     d.on_call,
//     d.name,
//     d.contact,
//   ]);

//   autoTable(doc, {
//     head: [["#", "ڈیوٹی", "نام", "رابطہ"]],
//     body: urduData,
//     startY: 50,
//     theme: "grid",
//     styles: {
//       font: "Jameel",
//       fontSize: 10,
//       halign: "center",
//     },
//     headStyles: {
//       fillColor: [204, 204, 255],
//       textColor: 0,
//       fontSize: 12,
//     },
//     alternateRowStyles: {
//       fillColor: [245, 245, 245],
//     },
//   });

//   doc.save(`ڈیوٹی روسٹر-${fileDate}.pdf`);
// };

//   const exportToPDF = () => {
//   const doc = new jsPDF({ orientation: "landscape" });
//   const pageWidth = doc.internal.pageSize.getWidth();
//   const imgLeft = new Image();
//   const imgRight = new Image();

//   imgLeft.src = logoLeft;
//   imgRight.src = logoRight;

//   const rolesToPrint = Object.keys(selectedRoles).filter((r) => selectedRoles[r]);
//   let startY = 60;

//   rolesToPrint.forEach((roleKey) => {
//     const isNurse = roleKey === "Nurse";
//     const isFireTeam = roleKey === "FireFighting";
//     const isRapidGround = roleKey === "RapidResponseGround";
//     const isRapidFirst = roleKey === "RapidResponseFirst";

//     let data = [];

//     if (isFireTeam) {
//       data = fireTeam
//         .filter((d) => d.created_at === filter.date)
//         .map((d) => ({
//           delegation: d.delegation,
//           responsible: d.responsible,
//         }));
//     } else if (isRapidGround) {
//       data = filtered
//         .filter((d) => d.role === "Rapid Response Team Ground Floor")
//         .map((d) => ({
//           on_call: d.on_call,
//           name: d.name,
//         }));
//     } else if (isRapidFirst) {
//       data = filtered
//         .filter((d) => d.role === "Rapid Response Team First Floor")
//         .map((d) => ({
//           on_call: d.on_call,
//           name: d.name,
//         }));
//     } else {
//       data = filtered
//         .filter((d) => d.role.toLowerCase() === roleKey.toLowerCase())
//         .map((d) => ({
//           name: d.name,
//           contact: d.contact,
//           role: d.role,
//           on_call: d.on_call,
//         }));
//     }

//     if (data.length > 0) {
//       autoTable(doc, {
//         head: isFireTeam
//           ? [
//               [
//                 {
//                   content: "Fire Fighting Team (Morning / Evening / Night)",
//                   colSpan: 3,
//                   styles: {
//                     halign: "center",
//                     fontStyle: "bold",
//                     fontSize: 14,
//                     textColor: [0, 0, 0],
//                     fillColor: [255, 255, 204],
//                     lineWidth: 0.5,
//                     lineColor: [100, 100, 100],
//                     cellPadding: 6,
//                   },
//                 },
//               ],
//               ["#", "Delegation of Responsibility", "Responsible Person"],
//             ]
//           : isRapidGround
//           ? [
//               [
//                 {
//                   content: "Rapid Response Team (Ground Floor)",
//                   colSpan: 4,
//                   styles: {
//                     halign: "center",
//                     fontStyle: "bold",
//                     fontSize: 14,
//                     textColor: [0, 0, 0],
//                     fillColor: [204, 229, 255],
//                     lineWidth: 0.5,
//                     lineColor: [80, 80, 80],
//                     cellPadding: 6,
//                   },
//                 },
//               ],
//               ["#", "On-Call Duty", "Doctor Name"],
//             ]
//           : isRapidFirst
//           ? [
//               [
//                 {
//                   content: "Rapid Response Team (First Floor)",
//                   colSpan: 4,
//                   styles: {
//                     halign: "center",
//                     fontStyle: "bold",
//                     fontSize: 14,
//                     textColor: [0, 0, 0],
//                     fillColor: [204, 255, 229],
//                     lineWidth: 0.5,
//                     lineColor: [60, 60, 60],
//                     cellPadding: 6,
//                   },
//                 },
//               ],
//               ["#", "On-Call Duty", "Doctor Name"],
//             ]
//           : isNurse
//           ? [["#", "Nurse", "Designation", "Duty"]]
//           : [["#", "On Call Duties", "Doctor Name", "Contact"]],
//        body: data.map((d, i) => {
//   if (isFireTeam) {
//     return [i + 1, d.delegation, d.responsible];
//   } else if (isRapidGround || isRapidFirst) {
//     return [i + 1, d.on_call, d.name]; // ✅ Only 2 data columns for Rapid
//   } else {
//     return [i + 1, d.on_call, d.name, d.contact]; // Default
//   }
// }),
//         startY,
//         theme: "grid",
//         headStyles: {
//           fillColor: [0, 102, 204],
//           textColor: 255,
//           fontSize: 14,
//           fontStyle: "bold",
//           halign: "center",
//         },
//         bodyStyles: {
//           fontSize: 10,
//           textColor: [0, 0, 0],
//           halign: "center",
//         },
//         alternateRowStyles: {
//           fillColor: [240, 248, 255],
//         },
//         columnStyles: {
//           1: { halign: "left", fillColor: [204, 255, 204] },
//           2: { halign: "left" },
//           3: { halign: "center" },
//         },
//         margin: { top: 50 },
//         showHead: "everyPage",
//         pageBreak: "auto",
//         rowPageBreak: "avoid",
//         pageBreakInside: false,
//         didDrawPage: () => {
//           doc.addImage(imgLeft, "PNG", 10, 15, 25, 22);
//           doc.addImage(imgRight, "PNG", pageWidth - 35, 15, 25, 25);
//           doc.setFontSize(28);
//           doc.setFont("helvetica", "bold");
//           doc.text("Rawalpindi Institute of Cardiology", pageWidth / 2, 25, {
//             align: "center",
//           });
//           doc.setFontSize(11);
//           doc.setFont("helvetica", "normal");
//           doc.text(
//             "PART 1 (Evening / Night Duty Roster)",
//             pageWidth / 2,
//             32,
//             {
//               align: "center",
//             }
//           );
//           doc.text(`(${readableDate})`, pageWidth / 2, 40, {
//             align: "center",
//           });
//         },
//       });

//       startY = doc.lastAutoTable.finalY + 20;
//     }
//   });

//   const pageCount = doc.internal.getNumberOfPages();
//   for (let i = 1; i <= pageCount; i++) {
//     doc.setPage(i);
//     doc.setFontSize(9);
//     doc.setTextColor(150);
//     doc.text(
//       `Page ${i} of ${pageCount}`,
//       pageWidth / 2,
//       doc.internal.pageSize.getHeight() - 10,
//       { align: "center" }
//     );
//   }

//   doc.save(`Part 1 Evening - Night Duty Roaster-${fileDate}.pdf`);
// };

// const exportBothPDFs = async () => {
//   exportToPDF(); // English
//   setTimeout(() => {
//     exportToUrduPDF(); // Urdu, slight delay to avoid overlap
//   }, 500);
// };


//   const exportToExcel = () => {
//     const wsData = [
//       ["", "", "Rawalpindi Institute of Cardiology", ""],
//       ["", "", "PART 1 (Evening / Night Duty Roster)", ""],
//       ["", "", `(${readableDate})`, ""],
//       [""],
//       ["#", "On Call", "Doctor Name", "Contact"],
//       ...filtered.map((d, i) => [i + 1, d.on_call, d.name, d.contact])
//     ];
//     const ws = XLSX.utils.aoa_to_sheet(wsData);
//     const wb = XLSX.utils.book_new();
//     XLSX.utils.book_append_sheet(wb, ws, "Duty Roster");
//     const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
//     saveAs(new Blob([wbout], { type: "application/octet-stream" }), `Duty-Roaster-${fileDate}.xlsx`);
//   };

//   const exportToImageVideo = async () => {
//     const canvas = await html2canvas(tableRef.current);
//     const link = document.createElement("a");
//     link.href = canvas.toDataURL("image/webp");
//     link.download = `Duty-Roaster-${fileDate}.jpg`;
//     link.click();
//     alert("For video: Use screen recording tool to export this as MP4.");
//   };

//   const isFilterActive = filter.date || filter.name || filter.section;

//   return (

//     <div>
//     {/* 🔷 Shared Navbar */}
//     <nav className="navbar navbar-expand-lg bg-white shadow-sm rounded-bottom-4 px-4 py-3 mb-4">
//       <div className="container-fluid">
//         <a className="navbar-brand fw-bold text-primary fs-4" href="#">
//           🏥 RIC Duty Panel
//         </a>
//         <div className="d-flex ms-auto gap-3">
//           <button
//             className="btn btn-outline-primary rounded-3"
//             onClick={() => window.location.href = "/entry/roaster/dutyform"}
//           >
//             ➕ Add Duty
//           </button>
//           <button
//             className="btn btn-outline-danger rounded-3"
//             onClick={() => {
//               localStorage.clear();
//               window.location.href = "/roaster/login";
//             }}
//           >
//             🚪 Logout
//           </button>
//         </div>
//       </div>
//     </nav>

//     <div className="container mt-4">
//       <div className="bg-white shadow-sm p-4 rounded text-center border border-2 border-light mb-4">
//         <div className="d-flex justify-content-between align-items-center mb-2">
//           <img src={logoLeft} alt="Logo Left" style={{ height: "50px" }} />
//           <div>
//             <h4 className="fw-bold text-primary m-0">Rawalpindi Institute of Cardiology</h4>
//             <div style={{ fontWeight: "600", fontSize: "16px", color: "#2c3e50" }}>
//               PART 1 (Evening / Night Duty Roster)
//             </div>
//             <div style={{ fontSize: "14px", color: "#7f8c8d" }}>({readableDate})</div>
//           </div>
//           <img src={logoRight} alt="Logo Right" style={{ height: "50px" }} />
//         </div>
//       </div>

//      <div className="row g-2 mb-4">
//   <div className="col-md-3">
//     <label className="form-label">Export Roles</label>

//     {/* Doctor */}
//     <div className="form-check">
//       <input
//         className="form-check-input"
//         type="checkbox"
//         id="doctorCheck"
//         checked={selectedRoles.Doctor}
//         onChange={() =>
//           setSelectedRoles((prev) => ({ ...prev, Doctor: !prev.Doctor }))
//         }
//       />
//       <label className="form-check-label" htmlFor="doctorCheck">
//         Doctor
//       </label>
//     </div>

//     {/* Nurse */}
//     <div className="form-check">
//       <input
//         className="form-check-input"
//         type="checkbox"
//         id="nurseCheck"
//         checked={selectedRoles.Nurse}
//         onChange={() =>
//           setSelectedRoles((prev) => ({ ...prev, Nurse: !prev.Nurse }))
//         }
//       />
//       <label className="form-check-label" htmlFor="nurseCheck">
//         Nurse
//       </label>
//     </div>

//     {/* Fire Fighting Team */}
//     <div className="form-check">
//       <input
//         className="form-check-input"
//         type="checkbox"
//         id="fireCheck"
//         checked={selectedRoles.FireFighting}
//         onChange={() =>
//           setSelectedRoles((prev) => ({
//             ...prev,
//             FireFighting: !prev.FireFighting,
//           }))
//         }
//       />
//       <label className="form-check-label" htmlFor="fireCheck">
//         Fire Fighting Team
//       </label>
//     </div>

//     {/* Rapid Response Ground Floor */}
//     <div className="form-check">
//       <input
//         className="form-check-input"
//         type="checkbox"
//         id="rrtGroundCheck"
//         checked={selectedRoles.RapidResponseGround}
//         onChange={() =>
//           setSelectedRoles((prev) => ({
//             ...prev,
//             RapidResponseGround: !prev.RapidResponseGround,
//           }))
//         }
//       />
//       <label className="form-check-label" htmlFor="rrtGroundCheck">
//         Rapid Response Team (Ground Floor)
//       </label>
//     </div>

//     {/* ✅ Rapid Response First Floor */}
//     <div className="form-check">
//       <input
//         className="form-check-input"
//         type="checkbox"
//         id="rrtFirstCheck"
//         checked={selectedRoles.RapidResponseFirst}
//         onChange={() =>
//           setSelectedRoles((prev) => ({
//             ...prev,
//             RapidResponseFirst: !prev.RapidResponseFirst,
//           }))
//         }
//       />
//       <label className="form-check-label" htmlFor="rrtFirstCheck">
//         Rapid Response Team (First Floor)
//       </label>
//     </div>
//   </div>
// </div>




//       <div className="row g-2 mb-4">
//         <div className="col-md-3">
//           <label className="form-label">Filter by Date</label>
//           <input
//             type="date"
//             className="form-control"
//             value={filter.date}
//             onChange={(e) => {
//               setFilter({ ...filter, date: e.target.value });
//               setCurrentPage(1);
//             }}
//           />
//         </div>
//         <div className="col-md-3">
//           <label className="form-label">Filter by Section</label>
//           <input
//             type="text"
//             className="form-control"
//             placeholder="e.g. ER, OT"
//             value={filter.section}
//             onChange={(e) => {
//               setFilter({ ...filter, section: e.target.value });
//               setCurrentPage(1);
//             }}
//           />
//         </div>
//         <div className="col-md-3">
//           <label className="form-label">Filter by Doctor</label>
//           <select
//             className="form-select"
//             value={filter.name}
//             onChange={(e) => {
//               setFilter({ ...filter, name: e.target.value });
//               setCurrentPage(1);
//             }}
//           >
//             <option value="">All</option>
//             {doctorList.map((name, i) => (
//               <option key={i} value={name}>{name}</option>
//             ))}
//           </select>
//         </div>
//         <div className="col-md-3 d-flex align-items-end">
//           <button
//             className="btn btn-secondary w-100"
//             onClick={() => setFilter({ date: "", section: "", name: "" })}
//           >
//             Reset Filters
//           </button>
//         </div>
//       </div>

//       {isFilterActive && (
//         <>
//           <div className="d-flex justify-content-between align-items-center mb-2">
//             <h5 className="text-success fw-semibold">🗓️ Daily Duty Roaster</h5>
//             <div>
//               <button className="btn btn-outline-danger btn-sm me-2" onClick={exportToPDF}>Export PDF</button>
//               <button className="btn btn-outline-success btn-sm me-2" onClick={exportToExcel}>Export Excel</button>
//               <button className="btn btn-outline-primary btn-sm" onClick={exportToImageVideo}>Export JPG / Video</button>

//               <button className="btn btn-primary m-2" onClick={exportBothPDFs}>
//   📄 Export Both (English + Urdu)
// </button>
//             </div>
//           </div>

//           <div ref={tableRef} className="bg-white shadow-sm p-3 rounded border border-light">
//             <table className="table table-bordered table-hover align-middle">
//               <thead className="table-dark text-center">
//                 <tr>
//                   <th>#</th>
//                   <th>Name</th>
//                   <th>Contact</th>
//                   <th>Role</th>
//                   <th>Section</th>
//                   <th>On Call</th>
//                   <th>Edit</th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {currentItems.length > 0 ? (
//                   currentItems.map((d, i) => {
//                     const actualIndex = indexOfFirstItem + i;
//                     const isEditing = editingIndex === d.id;

//                     return (
//                       <tr key={d.id || i}>
//                         <td className="text-center">{actualIndex + 1}</td>
//                         {isEditing ? (
//                           <>
//                             <td><input className="form-control" value={editData.name || ""} onChange={(e) => handleEditChange("name", e.target.value)} /></td>
//                             <td><input className="form-control" value={editData.contact || ""} onChange={(e) => handleEditChange("contact", e.target.value)} /></td>
//                             <td><input className="form-control" value={editData.role || ""} onChange={(e) => handleEditChange("role", e.target.value)} /></td>
//                             <td><input className="form-control" value={editData.section || ""} onChange={(e) => handleEditChange("section", e.target.value)} /></td>
//                             <td><input className="form-control" value={editData.on_call || ""} onChange={(e) => handleEditChange("on_call", e.target.value)} /></td>
//                             <td>
//                               <button className="btn btn-sm btn-success me-1" onClick={handleSaveEdit}>Save</button>
//                               <button className="btn btn-sm btn-secondary" onClick={handleCancelEdit}>Cancel</button>
//                             </td>
//                           </>
//                         ) : (
//                           <>
//                             <td>{d.name}</td>
//                             <td>{d.contact}</td>
//                             <td>{d.role}</td>
//                             <td>{d.section}</td>
//                             <td>{d.on_call}</td>
//                             <td>
//                               <button className="btn btn-sm btn-primary" onClick={() => handleEdit(d.id)}>Edit</button>
//                             </td>
//                           </>
//                         )}
//                       </tr>
//                     );
//                   })
//                 ) : (
//                   <tr>
//                     <td colSpan="7" className="text-center text-muted">No data found</td>
//                   </tr>
//                 )}
//               </tbody>
//             </table>

//             {totalPages > 1 && (
//               <div className="d-flex justify-content-center mt-3">
//                 <nav>
//                   <ul className="pagination pagination-sm">
//                     {[...Array(totalPages).keys()].map((page) => (
//                       <li key={page} className={`page-item ${page + 1 === currentPage ? "active" : ""}`}>
//                         <button className="page-link" onClick={() => setCurrentPage(page + 1)}>{page + 1}</button>
//                       </li>
//                     ))}
//                   </ul>
//                 </nav>
//               </div>
//             )}
//           </div>
//         </>
//       )}
//     </div>
//     </div>
//   );
// };

// export default DutyList;





// MODIFIED DutyList with role-based checkboxes for export only
import React, { useEffect, useState, useRef } from "react";
import axios from "axios";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import html2canvas from "html2canvas";
import * as XLSX from "xlsx";
import { saveAs } from "file-saver";

import logoLeft from "../../assets/img/logo/new-logo.png";
import logoRight from "../../assets/img/logo/punjab-logo.png";

const translateText = async (text) => {
  if (!text) return "";
  try {
    const res = await fetch(
      `https://translate.googleapis.com/translate_a/single?client=gtx&sl=en&tl=ur&dt=t&q=${encodeURIComponent(
        text
      )}`
    );
    const json = await res.json();
    return json?.[0]?.[0]?.[0] || text;
  } catch {
    return text;
  }
};






const DutyList = () => {
  const [duties, setDuties] = useState([]);
  const [filter, setFilter] = useState({ date: "", section: "", name: "" });
  const [doctorList, setDoctorList] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editData, setEditData] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [selectedRoles, setSelectedRoles] = useState({
    Doctor: true,
    Nurse: false,
    FireFighting: false,
    RapidResponseGround: false,
    RapidResponseFirst: false, // ✅ NEW ROLE
  });
  const [fireTeam, setFireTeam] = useState([]);
  const [urduData, setUrduData] = useState([]);
  const [loading, setLoading] = useState(false);
  const printRef = useRef();

  const itemsPerPage = 10;
  const tableRef = useRef();
  const fileDate = filter.date || new Date().toISOString().split("T")[0];
  const readableDate = filter.date
    ? new Date(filter.date).toLocaleDateString("en-GB")
    : new Date().toLocaleDateString("en-GB");

  useEffect(() => {
    axios.get("https://ricgop.online/backend/getDuties.php").then((res) => {
      const cleaned = res.data.map((d) => ({
        ...d,
        name: d.name.trim(),
        contact: d.contact.trim(),
        role: d.role.trim(),
        section: d.section.trim(),
        on_call: d.on_call.trim(),
        duty_date: d.duty_date.trim(),
      }));
      setDuties(cleaned);
      const names = [...new Set(cleaned.map((d) => d.name))];
      setDoctorList(names);
            
    });

    

    axios.get("https://ricgop.online/backend/getFireTeam.php").then((res) => {
      const fireCleaned = res.data.map((f) => ({
        delegation: (f.delegation_field || "").trim(),
        responsible: (f.responsible_person || "").trim(),
        created_at: (f.created_at || "").trim(),
      }));
      setFireTeam(fireCleaned);
    });
  }, []);


  

  const filtered = duties.filter(
    (d) =>
      (!filter.date || d.duty_date === filter.date) &&
      (!filter.section ||
        d.section.toLowerCase().includes(filter.section.toLowerCase())) &&
      (!filter.name || d.name === filter.name)
  );

  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filtered.slice(indexOfFirstItem, indexOfLastItem);
  const totalPages = Math.ceil(filtered.length / itemsPerPage);
  const handlePageChange = (pageNum) => {
  setCurrentPage(pageNum);
};


useEffect(() => {
  const translateCurrentItems = async () => {
    setLoading(true);
    try {
      const translated = await Promise.all(
        currentItems.map(async (row, i) => ({
          no: await translateText((indexOfFirstItem + i + 1).toString()),
          on_call: await translateText(row.on_call || ""),
          name: await translateText(row.name || ""),
          contact: await translateText(row.contact || ""),
        }))
      );
      console.log("✅ Urdu Data Ready:", translated);
      setUrduData(translated);
    } catch (err) {
      console.error("Translation failed:", err);
      setUrduData([]);
    } finally {
      setLoading(false);
    }
  };

  if (currentItems.length > 0) {
    translateCurrentItems();
  } else {
    setUrduData([]);
    setLoading(false);
  }
}, [currentPage, indexOfFirstItem]); // ✅ Don't use currentItems here



// const handleTranslateToUrdu = async () => {
//   setLoading(true);
//   try {
//     const translated = await Promise.all(
//       currentItems.map(async (row, i) => ({
//         no: await translateText((indexOfFirstItem + i + 1).toString()),
//         on_call: await translateText(row.on_call),
//         name: await translateText(row.name),
//         contact: await translateText(row.contact),
//       }))
//     );
//     setUrduData(translated);
//   } catch (err) {
//     console.error("Translation failed:", err);
//     setUrduData([]);
//   } finally {
//     setLoading(false);
//   }
// };


  const handleEdit = (id) => {
    const duty = duties.find((d) => d.id === id);
    if (duty) {
      setEditingIndex(id);
      setEditData({ ...duty });
    }
  };

  const handleEditChange = (field, value) => {
    setEditData((prev) => ({ ...prev, [field]: value }));
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditData({});
  };

const handleSaveEdit = async () => {
  try {
    const response = await fetch("https://ricgop.online/backend/updateDuty.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        id: editingIndex,
        name: editData.name,
        contact: editData.contact,
        role: editData.role,
        section: editData.section,
        on_call: editData.on_call,
      }),
    });

    const result = await response.json();

    if (result.success) {
      const updated = duties.map((d) =>
        d.id === editingIndex ? { ...d, ...editData } : d
      );
      setDuties(updated);
      setEditingIndex(null);
      setEditData({});
    } else {
      alert("❌ Failed to update: " + result.error);
    }
  } catch (error) {
    console.error("Error updating duty:", error);
    alert("❌ Error saving changes.");
  }
};

const handleDelete = async (id) => {
  if (!window.confirm("Are you sure you want to delete this record?")) return;

  try {
    const response = await fetch("https://ricgop.online/backend/deleteDuty.php", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ id }),
    });

    const result = await response.json();

    if (result.success) {
      const updated = duties.filter((d) => d.id !== id);
      setDuties(updated);
    } else {
      alert("❌ Failed to delete: " + result.error);
    }
  } catch (error) {
    console.error("Error deleting duty:", error);
    alert("❌ Error deleting record.");
  }
};


  const exportToPDF = () => {
  const doc = new jsPDF({ orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const imgLeft = new Image();
  const imgRight = new Image();

  imgLeft.src = logoLeft;
  imgRight.src = logoRight;

  const rolesToPrint = Object.keys(selectedRoles).filter((r) => selectedRoles[r]);
  let startY = 60;

  rolesToPrint.forEach((roleKey) => {
    const isNurse = roleKey === "Nurse";
    const isFireTeam = roleKey === "FireFighting";
    const isRapidGround = roleKey === "RapidResponseGround";
    const isRapidFirst = roleKey === "RapidResponseFirst";

    let data = [];

    if (isFireTeam) {
      data = fireTeam
        .filter((d) => d.created_at === filter.date)
        .map((d) => ({
          delegation: d.delegation,
          responsible: d.responsible,
        }));
    } else if (isRapidGround) {
      data = filtered
        .filter((d) => d.role === "Rapid Response Team Ground Floor")
        .map((d) => ({
          on_call: d.on_call,
          name: d.name,
        }));
    } else if (isRapidFirst) {
      data = filtered
        .filter((d) => d.role === "Rapid Response Team First Floor")
        .map((d) => ({
          on_call: d.on_call,
          name: d.name,
        }));
    } else {
      data = filtered
        .filter((d) => d.role.toLowerCase() === roleKey.toLowerCase())
        .map((d) => ({
          name: d.name,
          contact: d.contact,
          role: d.role,
          on_call: d.on_call,
        }));
    }

    if (data.length > 0) {
      autoTable(doc, {
        head: isFireTeam
          ? [
              [
                {
                  content: "Fire Fighting Team (Morning / Evening / Night)",
                  colSpan: 3,
                  styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 14,
                    textColor: [0, 0, 0],
                    fillColor: [255, 255, 204],
                    lineWidth: 0.5,
                    lineColor: [100, 100, 100],
                    cellPadding: 6,
                  },
                },
              ],
              ["#", "Delegation of Responsibility", "Responsible Person"],
            ]
          : isRapidGround
          ? [
              [
                {
                  content: "Code Blue Team (Ground Floor / Emergency)",
                  colSpan: 4,
                  styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 14,
                    textColor: [0, 0, 0],
                    fillColor: [204, 229, 255],
                    lineWidth: 0.5,
                    lineColor: [80, 80, 80],
                    cellPadding: 6,
                  },
                },
              ],
              ["#", "On-Call Duty", "Doctor Name"],
            ]
          : isRapidFirst
          ? [
              [
                {
                  content: "Code Blue Team (First Floor)",
                  colSpan: 4,
                  styles: {
                    halign: "center",
                    fontStyle: "bold",
                    fontSize: 14,
                    textColor: [0, 0, 0],
                    fillColor: [204, 255, 229],
                    lineWidth: 0.5,
                    lineColor: [60, 60, 60],
                    cellPadding: 6,
                  },
                },
              ],
              ["#", "On-Call Duty", "Doctor Name"],
            ]
          : isNurse
          ? [["#", "Nurse", "Designation", "Duty"]]
          : [["#", "On Call Duties", "Doctor Name", "Contact"]],
       body: data.map((d, i) => {
  if (isFireTeam) {
    return [i + 1, d.delegation, d.responsible];
  } else if (isRapidGround || isRapidFirst) {
    return [i + 1, d.on_call, d.name]; // ✅ Only 2 data columns for Rapid
  } else {
    return [i + 1, d.on_call, d.name, d.contact]; // Default
  }
}),
        startY,
        theme: "grid",
        headStyles: {
          fillColor: [0, 102, 204],
          textColor: 255,
          fontSize: 14,
          fontStyle: "bold",
          halign: "center",
        },
        bodyStyles: {
          fontSize: 10,
          textColor: [0, 0, 0],
          halign: "center",
        },
        alternateRowStyles: {
          fillColor: [240, 248, 255],
        },
        columnStyles: {
          1: { halign: "left", fillColor: [204, 255, 204] },
          2: { halign: "left" },
          3: { halign: "center" },
        },
        margin: { top: 50 },
        showHead: "everyPage",
        pageBreak: "auto",
        rowPageBreak: "avoid",
        pageBreakInside: false,
        didDrawPage: () => {
          doc.addImage(imgLeft, "PNG", 10, 15, 25, 22);
          doc.addImage(imgRight, "PNG", pageWidth - 35, 15, 25, 25);
          doc.setFontSize(28);
          doc.setFont("helvetica", "bold");
          doc.text("Rawalpindi Institute of Cardiology", pageWidth / 2, 25, {
            align: "center",
          });
          doc.setFontSize(11);
          doc.setFont("helvetica", "normal");
          doc.text(
            "PART 1 (Evening / Night Duty Roster)",
            pageWidth / 2,
            32,
            {
              align: "center",
            }
          );
          doc.text(`(${readableDate})`, pageWidth / 2, 40, {
            align: "center",
          });
        },
      });

      startY = doc.lastAutoTable.finalY + 20;
    }
  });

  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(9);
    doc.setTextColor(150);
    doc.text(
      `Page ${i} of ${pageCount}`,
      pageWidth / 2,
      doc.internal.pageSize.getHeight() - 10,
      { align: "center" }
    );
  }

  doc.save(`Part 1 Evening - Night Duty Roaster-${fileDate}.pdf`);
};

  const screenshotRef = useRef();

  const handlePrint = () => {
    const printContents = printRef.current.innerHTML;
    const originalContents = document.body.innerHTML;
    document.body.innerHTML = printContents;
    window.print();
    document.body.innerHTML = originalContents;
  };

  const handleScreenshot = async () => {
    const canvas = await html2canvas(screenshotRef.current, { scale: 2 });
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/png");
    link.download = `Roster_${readableDate}.png`;
    link.click();
  };



 const exportToUrduPDF = async () => {
  const doc = new jsPDF({ orientation: "landscape" });
  const pageWidth = doc.internal.pageSize.getWidth();
  const imgLeft = new Image();
  const imgRight = new Image();
  imgLeft.src = logoLeft;
  imgRight.src = logoRight;

  const rolesToPrint = Object.keys(selectedRoles).filter((r) => selectedRoles[r]);
  let startY = 60;

  for (const roleKey of rolesToPrint) {
    const isNurse = roleKey === "Nurse";
    const isFireTeam = roleKey === "FireFighting";
    const isRapidGround = roleKey === "RapidResponseGround";
    const isRapidFirst = roleKey === "RapidResponseFirst";

    let rawData = [];

    if (isFireTeam) {
      rawData = fireTeam
        .filter((d) => d.created_at === filter.date)
        .map((d) => ({
          delegation: d.delegation,
          responsible: d.responsible,
        }));
    } else if (isRapidGround) {
      rawData = filtered
        .filter((d) => d.role === "Rapid Response Team Ground Floor")
        .map((d) => ({
          on_call: d.on_call,
          name: d.name,
        }));
    } else if (isRapidFirst) {
      rawData = filtered
        .filter((d) => d.role === "Rapid Response Team First Floor")
        .map((d) => ({
          on_call: d.on_call,
          name: d.name,
        }));
    } else if (isNurse) {
      rawData = filtered
        .filter((d) => d.role === "Nurse")
        .map((d) => ({
          name: d.name,
          contact: d.contact,
          designation: d.designation,
          on_call: d.on_call,
        }));
    } else {
      rawData = filtered
        .filter((d) => d.role.toLowerCase() === roleKey.toLowerCase())
        .map((d) => ({
          name: d.name,
          contact: d.contact,
          on_call: d.on_call,
        }));
    }

    // Translate each row based on the role
    const data = await Promise.all(
      rawData.map(async (d, i) => {
        if (isFireTeam) {
          return [
            i + 1,
            await translateText(d.delegation),
            await translateText(d.responsible),
          ];
        } else if (isRapidGround || isRapidFirst) {
          return [
            i + 1,
            await translateText(d.on_call),
            await translateText(d.name),
          ];
        } else if (isNurse) {
          return [
            i + 1,
            await translateText(d.name),
            await translateText(d.designation),
            await translateText(d.on_call),
          ];
        } else {
          return [
            i + 1,
            await translateText(d.on_call),
            await translateText(d.name),
            await translateText(d.contact),
          ];
        }
      })
    );

    autoTable(doc, {
      head: isFireTeam
        ? [["#", "تفویض کردہ ذمہ داری", "ذمہ دار فرد"]]
        : isRapidGround || isRapidFirst
        ? [["#", "ڈیوٹی", "ڈاکٹر کا نام"]]
        : isNurse
        ? [["#", "نرس", "عہدہ", "ڈیوٹی"]]
        : [["#", "ڈیوٹی", "ڈاکٹر کا نام", "رابطہ"]],
      body: data,
      startY,
      theme: "grid",
      headStyles: {
        font: "NotoNastaliqUrdu",
        fontSize: 12,
        halign: "center",
      },
      bodyStyles: {
        font: "NotoNastaliqUrdu",
        fontSize: 10,
        halign: "center",
      },
      didDrawPage: () => {
        doc.addImage(imgLeft, "PNG", 10, 15, 25, 22);
        doc.addImage(imgRight, "PNG", pageWidth - 35, 15, 25, 25);
        doc.setFont("NotoNastaliqUrdu", "bold");
        doc.setFontSize(18);
        doc.text("راولپنڈی انسٹی ٹیوٹ آف کارڈیالوجی", pageWidth / 2, 25, {
          align: "center",
        });
        doc.setFontSize(12);
        doc.text("حصہ 1 (شام / رات کی ڈیوٹی روستر)", pageWidth / 2, 35, {
          align: "center",
        });
        doc.text(`(${fileDate})`, pageWidth / 2, 42, { align: "center" });
      },
    });

    startY = doc.lastAutoTable.finalY + 20;
  }

  // Add Urdu page numbers
  const pageCount = doc.internal.getNumberOfPages();
  for (let i = 1; i <= pageCount; i++) {
    doc.setPage(i);
    doc.setFontSize(9);
    doc.setTextColor(150);
    doc.text(
      `صفحہ ${i} از ${pageCount}`,
      pageWidth / 2,
      doc.internal.pageSize.getHeight() - 10,
      { align: "center" }
    );
  }

  doc.save(`حصہ-1-رات-ڈیوٹی-روستر-${fileDate}.pdf`);
};


  const exportBothPDFs = async () => {
    exportToPDF();
    setTimeout(exportToUrduPDF, 800);
  };


  const exportToExcel = () => {
    const wsData = [
      ["", "", "Rawalpindi Institute of Cardiology", ""],
      ["", "", "PART 1 (Evening / Night Duty Roster)", ""],
      ["", "", `(${readableDate})`, ""],
      [""],
      ["#", "On Call", "Doctor Name", "Contact"],
      ...filtered.map((d, i) => [i + 1, d.on_call, d.name, d.contact])
    ];
    const ws = XLSX.utils.aoa_to_sheet(wsData);
    const wb = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, "Duty Roster");
    const wbout = XLSX.write(wb, { bookType: "xlsx", type: "array" });
    saveAs(new Blob([wbout], { type: "application/octet-stream" }), `Duty-Roaster-${fileDate}.xlsx`);
  };

  const exportToImageVideo = async () => {
    const canvas = await html2canvas(tableRef.current);
    const link = document.createElement("a");
    link.href = canvas.toDataURL("image/webp");
    link.download = `Duty-Roaster-${fileDate}.jpg`;
    link.click();
    alert("For video: Use screen recording tool to export this as MP4.");
  };

  const isFilterActive = filter.date || filter.name || filter.section;


   useEffect(() => {
    const dropdown = document.querySelector(".dropdown");

    const showDropdown = () => {
      if (window.innerWidth >= 992) { // Only hover on desktop
        dropdown.classList.add("show");
        dropdown.querySelector(".dropdown-menu").classList.add("show");
      }
    };

    const hideDropdown = () => {
      dropdown.classList.remove("show");
      dropdown.querySelector(".dropdown-menu").classList.remove("show");
    };

    dropdown.addEventListener("mouseenter", showDropdown);
    dropdown.addEventListener("mouseleave", hideDropdown);

    return () => {
      dropdown.removeEventListener("mouseenter", showDropdown);
      dropdown.removeEventListener("mouseleave", hideDropdown);
    };
  }, []);

  return (

    <div>
      <nav className="navbar navbar-expand-lg bg-white shadow-sm px-4 py-3 mb-4 rounded-bottom-4">
      <div className="container-fluid">
        <a className="navbar-brand fw-bold text-primary fs-4" href="/">
          🏥 RIC Duty Panel
        </a>

        {/* Toggle button for mobile */}
        <button
          className="navbar-toggler"
          type="button"
          data-bs-toggle="collapse"
          data-bs-target="#navbarContent"
          aria-controls="navbarContent"
          aria-expanded="false"
          aria-label="Toggle navigation"
        >
          <span className="navbar-toggler-icon"></span>
        </button>

        <div className="collapse navbar-collapse" id="navbarContent">
          <ul className="navbar-nav ms-auto align-items-center gap-lg-3 mt-3 mt-lg-0">

            {/* 🔽 Roasters Dropdown */}
            <li className="nav-item dropdown">
              <button
                className="btn btn-outline-secondary dropdown-toggle rounded-3 w-100"
                type="button"
                id="roastersDropdown"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                📁 Roasters
              </button>
              <ul className="dropdown-menu" aria-labelledby="roastersDropdown">
                <li>
                  <a className="dropdown-item" href="/entry/roaster/dutylist">Part 1 Duty Roaster</a>
                </li>
                <li>
                  <a className="dropdown-item" href="/entry/roaster/ams">AMS Roaster</a>
                </li>
                <li>
                  <a className="dropdown-item" href="/entry/roaster/vvip">VVIP Movement Roaster</a>
                </li>
              </ul>
            </li>

            {/* 📋 Duty Forms */}
            <li className="nav-item">
              <button
                className="btn btn-outline-primary rounded-3 w-100"
                onClick={() => window.location.href = "/entry/roaster/dutyform"}
              >
                📋 Duty Forms
              </button>
            </li>

            {/* 🚪 Logout */}
            <li className="nav-item">
              <button
                className="btn btn-outline-danger rounded-3 w-100"
                onClick={() => {
                  localStorage.clear();
                  window.location.href = "/roaster/login";
                }}
              >
                🚪 Logout
              </button>
            </li>
          </ul>
        </div>
      </div>
    </nav>

    <div className="container mt-4">
      <div className="bg-white shadow-sm p-4 rounded text-center border border-2 border-light mb-4">
        <div className="d-flex justify-content-between align-items-center mb-2">
          <img src={logoLeft} alt="Logo Left" style={{ height: "50px" }} />
          <div>
            <h4 className="fw-bold text-primary m-0">Rawalpindi Institute of Cardiology</h4>
            <div style={{ fontWeight: "600", fontSize: "16px", color: "#2c3e50" }}>
              PART 1 (Evening / Night Duty Roster)
            </div>
            <div style={{ fontSize: "14px", color: "#7f8c8d" }}>({readableDate})</div>
          </div>
          <img src={logoRight} alt="Logo Right" style={{ height: "50px" }} />
        </div>
      </div>

     <div className="row g-2 mb-4">
  <div className="col-md-3">
    <label className="form-label">Export Roles</label>

    {/* Doctor */}
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id="doctorCheck"
        checked={selectedRoles.Doctor}
        onChange={() =>
          setSelectedRoles((prev) => ({ ...prev, Doctor: !prev.Doctor }))
        }
      />
      <label className="form-check-label" htmlFor="doctorCheck">
        Doctor
      </label>
    </div>

    {/* Nurse */}
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id="nurseCheck"
        checked={selectedRoles.Nurse}
        onChange={() =>
          setSelectedRoles((prev) => ({ ...prev, Nurse: !prev.Nurse }))
        }
      />
      <label className="form-check-label" htmlFor="nurseCheck">
        Nurse
      </label>
    </div>

    {/* Fire Fighting Team */}
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id="fireCheck"
        checked={selectedRoles.FireFighting}
        onChange={() =>
          setSelectedRoles((prev) => ({
            ...prev,
            FireFighting: !prev.FireFighting,
          }))
        }
      />
      <label className="form-check-label" htmlFor="fireCheck">
        Fire Fighting Team
      </label>
    </div>

    {/* Rapid Response Ground Floor */}
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id="rrtGroundCheck"
        checked={selectedRoles.RapidResponseGround}
        onChange={() =>
          setSelectedRoles((prev) => ({
            ...prev,
            RapidResponseGround: !prev.RapidResponseGround,
          }))
        }
      />
      <label className="form-check-label" htmlFor="rrtGroundCheck">
        Rapid Response Team (Ground Floor)
      </label>
    </div>

    {/* ✅ Rapid Response First Floor */}
    <div className="form-check">
      <input
        className="form-check-input"
        type="checkbox"
        id="rrtFirstCheck"
        checked={selectedRoles.RapidResponseFirst}
        onChange={() =>
          setSelectedRoles((prev) => ({
            ...prev,
            RapidResponseFirst: !prev.RapidResponseFirst,
          }))
        }
      />
      <label className="form-check-label" htmlFor="rrtFirstCheck">
        Rapid Response Team (First Floor)
      </label>
    </div>
  </div>
</div>




      <div className="row g-2 mb-4">
        <div className="col-md-3">
          <label className="form-label">Filter by Date</label>
          <input
            type="date"
            className="form-control"
            value={filter.date}
            onChange={(e) => {
              setFilter({ ...filter, date: e.target.value });
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Filter by Section</label>
          <input
            type="text"
            className="form-control"
            placeholder="e.g. ER, OT"
            value={filter.section}
            onChange={(e) => {
              setFilter({ ...filter, section: e.target.value });
              setCurrentPage(1);
            }}
          />
        </div>
        <div className="col-md-3">
          <label className="form-label">Filter by Doctor</label>
          <select
            className="form-select"
            value={filter.name}
            onChange={(e) => {
              setFilter({ ...filter, name: e.target.value });
              setCurrentPage(1);
            }}
          >
            <option value="">All</option>
            {doctorList.map((name, i) => (
              <option key={i} value={name}>{name}</option>
            ))}
          </select>
        </div>
        <div className="col-md-3 d-flex align-items-end">
          <button
            className="btn btn-secondary w-100"
            onClick={() => setFilter({ date: "", section: "", name: "" })}
          >
            Reset Filters
          </button>
        </div>
      </div>

      {isFilterActive && (
        <>
          <div className="d-flex justify-content-between align-items-center mb-2">
            <h5 className="text-success fw-semibold">🗓️ Daily Duty Roaster</h5>
            <div>
              <button className="btn btn-outline-danger btn-sm me-2" onClick={exportToPDF}>Export PDF</button>
              <button className="btn btn-outline-success btn-sm me-2" onClick={exportToExcel}>Export Excel</button>
              <button className="btn btn-outline-primary btn-sm" onClick={exportToImageVideo}>Export JPG / Video</button>
             
              {/* <button className="btn btn-outline-primary btn-sm" onClick={exportBothPDFs}>Export English & Urdu PDFs</button> */}
            </div>
          </div>

            <div className="container mt-5">
      <div className="d-flex justify-content-between align-items-center">
        <h5>📄 ڈیوٹی روسٹر (اردو)</h5>
       {/* <button
  className="btn btn-success mb-3"
  onClick={handleTranslateToUrdu}
  disabled={loading}
>
  {loading ? "ترجمہ ہو رہا ہے..." : "اردو میں ترجمہ کریں"}
</button> */}


                <button
                     className="btn btn-outline-success btn-sm me-2"
                     onClick={exportToUrduPDF}
                     disabled={loading}
                      >
                  {loading ? "ترجمہ ہو رہا ہے..." : "PDF ایکسپورٹ کریں"}
                </button>
           </div>


<div style={{ fontFamily: "'Jameel Noori Nastaleeq', serif", direction: "rtl" }}>
  {/* 🔘 Buttons */}
  <div style={{ textAlign: "center", margin: "20px 0" }}>
    <button onClick={handlePrint} style={buttonStyle}>
      🖨️ پرنٹ کریں
    </button>
    <button
      onClick={handleScreenshot}
      style={{ ...buttonStyle, backgroundColor: "#198754" }}
    >
      📸 اسکرین شاٹ
    </button>
  </div>

  {/* 📋 Urdu Roster + Header inside Screenshot */}
  <div
    ref={printRef}
    style={{
      background: "#fff",
      padding: "30px",
      margin: "auto",
      maxWidth: "1000px",
      boxShadow: "0 0 12px rgba(0,0,0,0.2)",
      borderRadius: "12px",
      border: "1px solid #e3e3e3",
    }}
  >
    {/* 📸 Screenshot Start */}
    <div
      ref={screenshotRef}
      style={{
        padding: "30px",
        backgroundColor: "#fff",
      }}
    >
      {/* 🏥 Header with Two Logos and Updated Urdu Title */}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "20px",
        }}
      >
        {/* Left Logo */}
        <img src={logoRight} alt="left logo" style={{ height: "90px" }} />

        {/* Centered Hospital Info */}
        <div style={{ flex: 1, textAlign: "center" }}>
          <h2 style={{ color: "#0d6efd", margin: 0 }}>
            راولپنڈی انسٹیٹیوٹ آف کارڈیالوجی
          </h2>
          <h4 style={{ margin: "0 0 4px 0" }}>حصہ اول (شام / رات کی ڈیوٹی روسٹر)</h4>
          <p style={{ margin: 0 }}>
            📅 تاریخ: <strong>{readableDate}</strong>
          </p>
        </div>

        {/* Right Logo */}
        <img src={logoLeft} alt="right logo" style={{ height: "80px" }} />
      </div>

      {/* 📊 Styled Urdu Table (English Theme) */}
      <table
        style={{
          width: "100%",
          borderCollapse: "separate",
          borderSpacing: 0,
          backgroundColor: "#fefefe",
          fontSize: "18px",
          borderRadius: "10px",
          overflow: "hidden",
          direction: "rtl",
        }}
      >
        <thead style={{ backgroundColor: "#0d6efd", color: "#fff" }}>
          <tr>
            <th style={thStyle}>نمبر</th>
            <th style={thStyle}>ڈیوٹی کا شعبہ</th>
            <th style={thStyle}>نام</th>
            <th style={thStyle}>رابطہ نمبر</th>
          </tr>
        </thead>
        <tbody>
          {loading ? (
            <tr>
              <td colSpan="4" style={{ textAlign: "center", padding: 30 }}>
                <div
                  style={{
                    width: "40px",
                    height: "40px",
                    border: "4px solid #0d6efd",
                    borderTop: "4px solid transparent",
                    borderRadius: "50%",
                    animation: "spin 1s linear infinite",
                    margin: "0 auto 10px",
                  }}
                />
                ترجمہ ہو رہا ہے...
                <style>{`
                  @keyframes spin {
                    0% { transform: rotate(0deg); }
                    100% { transform: rotate(360deg); }
                  }
                `}</style>
              </td>
            </tr>
          ) : urduData.length > 0 ? (
            urduData.map((r, i) => (
              <tr
                key={i}
                style={{
                  backgroundColor: i % 2 === 0 ? "#f0f8ff" : "#ffffff",
                }}
              >
                <td style={tdStyle}>{r.no}</td>
                <td style={tdStyle}>{r.on_call}</td>
                <td style={tdStyle}>{r.name}</td>
                <td style={tdStyle}>{r.contact}</td>
              </tr>
            ))
          ) : (
            <tr>
              <td colSpan="4" style={{ textAlign: "center", padding: "15px" }}>
                📭 کوئی ریکارڈ موجود نہیں
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
    {/* 📸 Screenshot End */}
  </div>
</div>



    </div>

   <div className="container my-4">
  <h4 className="fw-bold text-primary mb-3">📋 Duty Roster</h4>

  <div
    ref={tableRef}
    className="card shadow rounded-4 border-0"
    style={{ overflowX: "auto" }}
  >
    <div className="card-body p-0">
      <table className="table table-hover align-middle table-striped mb-0 text-center table-bordered border-light rounded">
      <thead className="table-light text-primary fw-semibold">
        <tr>
          <th>#</th>
          <th>Name</th>
          <th>Contact</th>
          <th>Role</th>
          <th>Section</th>
          <th>On Call</th>
          <th>Action</th>
        </tr>
      </thead>
      <tbody>
        {currentItems.length > 0 ? (
          currentItems.map((d, i) => {
            const actualIndex = indexOfFirstItem + i;
            const isEditing = editingIndex === d.id;

            return (
              <tr key={d.id || i}>
                <td className="fw-bold">{actualIndex + 1}</td>

                {isEditing ? (
                  <>
                    <td>
                      <input
                        className="form-control form-control-sm"
                        value={editData.name || ""}
                        onChange={(e) => handleEditChange("name", e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-control-sm"
                        value={editData.contact || ""}
                        onChange={(e) => handleEditChange("contact", e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-control-sm"
                        value={editData.role || ""}
                        onChange={(e) => handleEditChange("role", e.target.value)}
                      />
                    </td>
                    <td>
                      <input
                        className="form-control form-control-sm"
                        value={editData.section || ""}
                        onChange={(e) => handleEditChange("section", e.target.value)}
                      />
                    </td>
                  <td>
                    <textarea
                      className="form-control form-control-sm"
                      rows="5"
                      value={editData.on_call || ""}
                      onChange={(e) => handleEditChange("on_call", e.target.value)}
                    ></textarea>
                  </td>
                    <td>
                      <button
                        className="btn btn-success btn-sm me-1"
                        onClick={handleSaveEdit}
                      >
                        💾 Save
                      </button>
                      <button
                        className="btn btn-outline-secondary btn-sm"
                        onClick={handleCancelEdit}
                      >
                        ❌ Cancel
                      </button>
                    </td>
                  </>
                ) : (
                  <>
                    <td>{d.name}</td>
                    <td>{d.contact}</td>
                    <td>
                      <span className="badge bg-info text-dark px-2 py-1 rounded-pill">
                        {d.role}
                      </span>
                    </td>
                    <td>{d.section}</td>
                    <td>
                      <span className={`badge px-2 py-1 rounded-pill ${d.on_call === "Yes" ? "bg-success" : "bg-secondary"}`}>
                        {d.on_call}
                      </span>
                    </td>
                    <td>
                      <button
                        className="btn btn-sm btn-outline-primary me-1"
                        onClick={() => handleEdit(d.id)}
                      >
                        ✏️ Edit
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger"
                        onClick={() => handleDelete(d.id)}
                      >
                        🗑️ Delete
                      </button>
                    </td>
                  </>
                )}
              </tr>
            );
          })
        ) : (
          <tr>
            <td colSpan="7" className="text-muted py-4">
              No data found
            </td>
          </tr>
        )}
      </tbody>
    </table>
    </div>

    {/* Pagination */}
    {totalPages > 1 && (
      <div className="d-flex justify-content-center py-3">
        <nav>
          <ul className="pagination pagination-sm mb-0">
            {[...Array(totalPages).keys()].map((page) => (
              <li
                key={page}
                className={`page-item ${page + 1 === currentPage ? "active" : ""}`}
              >
                <button
                  className="page-link"
                  onClick={() => setCurrentPage(page + 1)}
                >
                  {page + 1}
                </button>
              </li>
            ))}
          </ul>
        </nav>
      </div>
    )}
  </div>
</div>

        </>
      )}
    </div>
    </div>
  );
};



// Styles
const buttonStyle = {
  padding: "8px 20px",
  backgroundColor: "#0d6efd",
  color: "#fff",
  border: "none",
  borderRadius: "8px",
  fontSize: "16px",
  cursor: "pointer",
  margin: "0 8px",
  boxShadow: "0 4px 6px rgba(0,0,0,0.1)",
};

const thStyle = {
  padding: "12px 14px",
  textAlign: "center",
  fontWeight: "600",
  border: "1px solid #e3e3e3",
};

const tdStyle = {
  padding: "12px 14px",
  textAlign: "center",
  border: "1px solid #e3e3e3",
};



export default DutyList;

